import { BsChevronDown } from "react-icons/bs";
import { FaChevronUp } from "react-icons/fa";
import { TbArrowDownCircle } from "react-icons/tb";

interface NeoJumbotronProps {
    id: string;
    title: string | React.ReactNode | React.ReactNode[];
    subtitle: string | React.ReactNode | React.ReactNode[];
    pageStyle?: React.CSSProperties;
    backgroundImage?: string;
    backgroundImageClass?: string;
    children?: React.ReactNode | React.ReactNode[];
    theme?: "light" | "dark";
    onNavigateBack?: () => void;
    onNavigate?: () => void;
}

export function NeoJumbotron(props: NeoJumbotronProps) {
    const pageStyle: React.CSSProperties = props.pageStyle || {};

    const onNavigateBack = () => {
        if (typeof props.onNavigateBack === "function") {
            props.onNavigateBack();
        }
    };

    const onNavigatePage = () => {
        if (typeof props.onNavigate === "function") {
            props.onNavigate();
        }
    };

    return (
        <section id={props.id} style={pageStyle} className={`four-cards-panel jumbotron ${props.theme || ""}`}>
            <div className="nav-back-action">
                <button
                    className="btn rotate-180"
                    onClick={onNavigateBack}
                >
                    <BsChevronDown className="icon" />
                </button>
            </div>

            <h1 className="title">
                {props.title}
            </h1>
            <h2 className="subtitle">
                {props.subtitle}
            </h2>

            {props.backgroundImage && (<img
                src={props.backgroundImage}
                alt=""
                className={`jumbotron-image absolute ${props.backgroundImageClass || ""}`}
            />)}

            <div className="right-feature-btn">
                <button
                    className="feature-btn prev"
                    onClick={onNavigateBack}
                >
                    <FaChevronUp className="icon previous-icon vertical-icon" />
                </button>

                <button
                    className="feature-btn "
                    onClick={onNavigatePage}
                >
                    Next
                    <TbArrowDownCircle className="icon vertical-icon" />
                </button>
            </div>

            <div className="right-feature-sm-btn flex-col gap-8 items-center">
                <button className="btn" onClick={onNavigatePage}>
                    <BsChevronDown className="icon" />
                </button>
            </div>

            {props.children}
        </section>
    );
}